export * from "./bike-icon.component";
